import api from '@/services/api'

export default {
    fetchEntities() {
        return api.get(`api/entities/`)
            .then(response => response.data)
    },
}